module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/transform.js
// module id = 500
// module chunks = 0